// Derived Visit column for target schools + Upcoming/Past grouping for visits.
import { fmtDay } from './conciergeTodoModel';
import { daysUntil } from './conciergeTabs';

const same = (a, b) => (a.unitid != null && b.unitid != null ? a.unitid === b.unitid
  : (a.college_name || '').trim().toLowerCase() === (b.college_name || '').trim().toLowerCase());

export function visitFor(school, visits, todayIso) {
  const mine = (visits || []).filter(v => v.visit_date && same(v, school));
  const next = mine.filter(v => v.visit_date >= todayIso).sort((a, b) => a.visit_date.localeCompare(b.visit_date))[0];
  if (next) return { text: `${next.visit_type === 'official' ? 'Official' : 'Unofficial'} · ${fmtDay(next.visit_date)}`, tone: 'green' };
  const last = mine.sort((a, b) => b.visit_date.localeCompare(a.visit_date))[0];
  if (last) return { text: `Visited ${fmtDay(last.visit_date)}`, tone: 'past' };
  return { text: 'No visit yet', tone: 'none' };
}

export function groupVisits(visits, todayIso) {
  const upcoming = []; const past = [];
  for (const v of visits || []) ((!v.visit_date || v.visit_date >= todayIso) ? upcoming : past).push(v);
  upcoming.sort((a, b) => (a.visit_date || '9999').localeCompare(b.visit_date || '9999'));
  past.sort((a, b) => b.visit_date.localeCompare(a.visit_date));
  return { upcoming, past };
}

export function visitRelative(visit, isTarget, todayIso) {
  if (!visit.visit_date) return 'No date yet';
  const n = daysUntil(visit.visit_date, todayIso);
  const rel = n === 0 ? 'Today' : (n > 0 ? `In ${n} day${n === 1 ? '' : 's'}` : `${-n} day${n === -1 ? '' : 's'} ago`);
  return isTarget ? `${rel} · target school` : rel;
}
